module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (259).72b23a3f.jpg";